import styled from 'styled-components';
import {
  Resizable,
} from 're-resizable';

export const Grid = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 1 1 100%;
  position: relative;
`;

export const GridLeft = styled(Resizable)`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 0;
  flex-shrink: 0;
  border-right: 1px solid #e1e1e1;
`;

export const GridLeftHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const GridLeftBody = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 1 1 0%;
`;

export const GridLeftFooter = styled.div`
  display: flex;
  flex-flow: row nowrap;
  position: absolute;
`;

export const GridRight = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 0;
`;

export const GridRightHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const GridRightBody = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 1 1 0%;
`;

export const GridRightFooter = styled.div`
  display: flex;
  flex-flow: row nowrap;
  position: absolute;
`;

export const Drag = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 16px;
  height: 30px;
  cursor: col-resize;
  user-select: none;
  position: absolute;
  top: 15px;
  right: 0;
`;

Drag.displayName = 'Drag';

export const Ellipsis = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  position: relative;
  top: 13px;
  background: rgba(255, 255, 255, .3);
  display: block;

  &:before,
  &:after {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .3);
    position: absolute;
    top: -9px;
    left: 0;
  }

  &:after {
    top: 9px;
  }
`;
